import { setInsurance } from './actions';
import InsuranceService from './InsuranceService';
import { currentPatientIdSelector } from '../patient';

// HELPERS
const toInsuranceRequest = ({
  id,
  isActive,
  provider,
  policyHolder,
  caseManager,
}) => ({
  id,
  isActive,
  provider: provider.name,
  groupNumber: provider.groupNumber,
  notes: provider.notes,
  providerPhone: provider.primaryPhoneNumber,
  providerExtension: provider.phoneExtension,
  policyNumber: provider.policyNumber,
  policyHolderFirstName: policyHolder.firstName,
  policyHolderLastName: policyHolder.lastName,
  policyHolderBirthday: policyHolder.birthday,
  caseManagerFirstName: caseManager.firstName,
  caseManagerLastName: caseManager.lastName,
  caseManagerPhone: caseManager.primaryPhoneNumber,
  caseManagerExtension: caseManager.phoneExtension,
});

const toRequest = (insuranceList, patientId) => ({
  insurance: insuranceList.map(toInsuranceRequest),
  patientId,
});

// THUNKS
export const fetchInsuranceAsync = () => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(InsuranceService.getByPatientId(patientId)).then(
    insuranceList => dispatch(setInsurance(insuranceList)),
  );
};

export const saveInsuranceAsync = insuranceList => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    InsuranceService.create(toRequest(insuranceList, patientId)),
  ).then(() => dispatch(setInsurance(insuranceList)));
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/insurance/thunks.js